import { Box } from '@mui/material';
import { useRef } from 'react';
import { CircularLoader } from '../CircularLoader';

interface VirtualListRowProps<T> {
  data: T[];
  index: number;
  renderRowComponent: (listItem: T) => JSX.Element;
}

export const VirtualListRow = <T extends unknown>({
  data,
  index,
  renderRowComponent,
}: VirtualListRowProps<T>) => {
  const rowRef = useRef<HTMLDivElement>();

  if (!data) {
    return null;
  }

  if (!data[index]) {
    return <CircularLoader size={20} />;
  }

  return (
    <Box ref={rowRef} height="100%">
      {renderRowComponent(data[index])}
    </Box>
  );
};
